import getJSONP, { HOST, postData } from "./request";
import { nowLang } from "../language";
import { getPlatform } from "../utils";

const PLATFORM = getPlatform();
const ajaxUrl = {
  getLanguage: {
    global: `//gactivityapi.${HOST}/survey/getSurveyLanguage`,
    gm99: `//eventsapi.gm99.com/survey/getSurveyLanguage`,
  },
  getQuestion: {
    global: `//gactivityapi.${HOST}/survey/getSurvey`,
    gm99: `//eventsapi.gm99.com/survey/getSurvey`,
  },
  submitQuestion: {
    global: `//gactivityapi.${HOST}/survey/collectAnswer`,
    gm99: `//eventsapi.gm99.com/survey/collectAnswer`,
  },
  collectInfo: {
    global: `//gactivityapi.${HOST}/survey/collectInfo`,
    gm99: `//eventsapi.gm99.com/survey/collectInfo`,
  },
  award: {
    global: `//gactivityapi.${HOST}/survey/award`,
    gm99: `//eventsapi.gm99.com/survey/award`,
  },
  awardLog: {
    global: `//gactivityapi.${HOST}/survey/awardLog`,
    gm99: `//eventsapi.gm99.com/survey/awardLog`,
  },
};

export const getLanguageList = function () {
  return getJSONP(ajaxUrl.getLanguage[PLATFORM], {
    id: window.id,
  });
};

export const getSurvey = function (nowLang) {
  return getJSONP(ajaxUrl.getQuestion[PLATFORM], {
    id: window.id,
    language: nowLang,
    preview: +window["isPreview"],
  });
};

export const submitQuestion = function (data) {
  const formData = new FormData();
  formData.append("id", window.id);
  formData.append("language", nowLang.value);
  formData.append("answer", JSON.stringify(data));
  return postData(ajaxUrl.submitQuestion[PLATFORM], formData);
};
export const submitInfo = function (data) {
  return getJSONP(ajaxUrl.collectInfo[PLATFORM], data);
};
export const getAward = function (data) {
  return getJSONP(ajaxUrl.award[PLATFORM], data);
};
export const getAwardLog = function () {
  return getJSONP(ajaxUrl.awardLog[PLATFORM], {
    id: window.id,
    language: nowLang.value,
  });
};
